import { React, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_TRACKER_CODE_QUERY } from '../../services/GraphQLQueries'
import { FiCopy } from 'react-icons/fi'
import '../../layouts/stylesheets/tooltip.css'
import '../../layouts/stylesheets/loader-style.css'
import { AiTwotoneSnippets } from 'react-icons/ai'

const Snippet = (props) => {
  const navigate = useNavigate()
  const [isCopied, setIsCopied] = useState(false)
  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'forward') {
        props.setActivePage('postbackJS')
      } else if (props.nav === 'back') {
        if (props.pageType === 'newTracker') {
          navigate('/trackers')
        } else {
          navigate('/first-tracker')
        }
      }
    }
    handleNav(props)
  }, [navigate, props])

  const { data, loading } = useQuery(GET_TRACKER_CODE_QUERY)

  const copyCode = async (e) => {
    e.preventDefault()
    setIsCopied(true)
    navigator.clipboard.writeText(data.trackerCode)
    let span = document.getElementById('copyMessage')
    span.style.zIndex = 999
    span.style.animation = 'fade 2s forwards'
    setTimeout(() => {
      span.style.animation = ''
      span.style.zIndex = -1
      setIsCopied(false)
    }, 2000)
  }

  return (
    <>
      {loading ? (
        <>
          <div className="loader-wrapper">
            <div className="flex justify-center items-center">
              <div className="grid gap-10">
                <div className="loader"></div>
                <div className="text-center font-unbounded">Loading...</div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex min-h-[calc(100vh-120px)] w-full items-center justify-center bg-white px-6 py-8 sm:px-8 lg:px-10">
          <div className="w-full text-center">
            {/* Header Section */}
            <div className="text-left mb-12">
              <h1 className="flex items-center text-gray-900 mb-4 font-unbounded">
                <AiTwotoneSnippets />
                PLACE A SNIPPET
              </h1>
              <h2 className="text-2xl  text-gray-800 mb-3 font-unbounded">
                Place the M-Tag in your website.
              </h2>
              <p className="text-lg text-gray-600">
                Paste this code as high in the &lt;head&gt; of the page as
                possible
              </p>
            </div>

            {/* Code Snippet Box */}
            <div className="bg-metrinome-shadow-green rounded-xl pt-7 pb-7 mb-8 relative p-4">
              <div className="absolute top-4 right-4">
                <button
                  onClick={copyCode}
                  className={`p-2 rounded-lg transition-all duration-200 transform ${
                    isCopied
                      ? 'bg-green-600 text-white scale-95 shadow-lg'
                      : 'text-green-600 hover:text-green-700 hover:bg-green-100 hover:scale-105'
                  }`}
                  title="Copy code"
                >
                  <FiCopy className="w-5 h-5" />
                </button>
              </div>

              <pre className="text-sm text-gray-800 font-mono whitespace-pre-wrap overflow-x-auto">
                <code>{data.trackerCode}</code>
              </pre>
            </div>

            {/* Copy Message Tooltip */}
            <span
              id="copyMessage"
              className="tooltiptext left-[41%] bottom-[100%] w-[10vw]"
            >
              Copied to clipboard
            </span>
          </div>
        </div>
      )}
    </>
  )
}

export default Snippet
